export default "__VITE_ASSET__DEqKomrB__"